export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID PENJUALAN",
    sort: false,
    align: "left",
    minWidth: "140px",
  },
  {
    id: "id_kunjungan",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tagihanId",
    disablePadding: true,
    label: "ID TAGIHAN",
    sort: false,
    align: "left",
  },
  {
    id: "unit_id",
    disablePadding: true,
    label: "UNIT",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "id_type_of_care",
    disablePadding: true,
    label: "JENIS RAWAT",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "date",
    disablePadding: true,
    label: "TANGGAL",
    sort: false,
    align: "left",
  },
  {
    id: "status_transaksi",
    disablePadding: true,
    label: "STATUS",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nama_rm",
    disablePadding: true,
    label: "NAMA RM",
    sort: false,
    align: "left",
  },
  {
    id: "id_rm",
    disablePadding: true,
    label: "ID RM",
    sort: false,
    align: "left",
  },
  {
    id: "jumlah",
    disablePadding: true,
    label: "JUMLAH",
    sort: false,
    align: "left",
  },
  {
    id: "discount",
    disablePadding: true,
    label: "POTONGAN",
    sort: false,
    align: "left",
  },

  {
    id: "jumlah_tax",
    disablePadding: true,
    label: "TAX",
    sort: false,
    align: "left",
  },
  {
    id: "jumlah_set_discount",
    disablePadding: true,
    label: "TOTAL",
    sort: false,
    align: "left",
  },
  {
    id: "bayar_jual",
    disablePadding: true,
    label: "PEMBAYARAN",
    sort: false,
    align: "left",
  },
  {
    id: "sisa",
    disablePadding: true,
    label: "SISA",
    sort: false,
    align: "left",
  },
];
